import { articleCardAudinorLocalized } from "./audinor";
import { articleCardJustLocalized } from "./just";
import { articleCardPortLocalized } from "./port";

export const portfolioArticleCards = [
  articleCardAudinorLocalized,
  articleCardPortLocalized,
  articleCardJustLocalized,
];
